<template>
    <div
        class="tw-flex tw-items-center tw-space-x-6"
        data-test-class="meeting-item"
        tabindex="0"
        @click="() => openEditModal(meeting._id)"
        @keyup.enter="() => openEditModal(meeting._id)"
    >
        <div class="hidden-xs tw-flex-grow-0 tw-p-2">
            <span v-for="participant in meeting.otherUsers.slice(0, 1)" :key="participant._id">
                <l-profile-picture :user="participant" size="xm" />
            </span>
        </div>

        <div class="tw-flex-1 md:tw-w-3/5">
            <div class="fake-link clickable tw-truncate">
                <!-- Meeting Title -->
                <span v-if="meeting.title && meeting.title !== ''">{{ meeting.title }}</span>
                <span v-else>{{ $t("userlist.show.labelMeetingWith") }}</span>
                <!--/Meeting Title -->
            </div>

            <div class="tw-flex tw-space-x-4 tw-justify-start tw-items-start tw-text-gray-500">
                <div v-if="meeting.cycle.state === 'enabled'" class="tw-flex-shrink-0">
                    <i class="fal fa-calendar tw-mr-1"></i>
                    {{ meeting.cycle.nextTime | moment("MMM D") }},
                    <span v-if="useMeridianTime">{{
                        meeting.cycle.nextTime | moment("HH:mm a")
                    }}</span>
                    <span v-else>{{ meeting.cycle.nextTime | moment("HH:mm") }}</span>
                </div>
                <div class="tw-truncate">
                    <i class="fal fa-users tw-mr-1"></i>
                    {{ participantNames }}
                </div>
            </div>
        </div>

        <div v-if="meeting.otherUsers.length > 1" class="hidden-xs tw-flex-grow-1">
            <span class="label label-primary tw-mr-6">+</span>

            <span
                v-for="participant in meeting.otherUsers.slice(1, 5)"
                :key="participant._id"
                class="meeting-item-picture"
            >
                <l-profile-picture :user="participant" size="xm" />
            </span>

            <span v-if="meeting.otherUsers.length > 5">
                <span class="label label-primary tw-ml-4"
                    >+ {{ (meeting.otherUsers.length - 5).toString() }}</span
                >
            </span>
        </div>
    </div>
</template>

<script>
import { concatNamesList } from "@/utils/format-user";

import LProfilePicture from "@/components/LProfilePicture";

export default {
    components: {
        LProfilePicture,
    },
    props: {
        meeting: {
            type: Object,
            required: true,
        },
        currentUser: {
            type: Object,
            required: true,
        },
        useMeridianTime: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        participantNames() {
            return this.meeting.otherUsers
                .slice(0, 8)
                .map(user => ({
                    firstname: user.firstname ?? "",
                    lastname: user.lastname?.charAt(0) ?? "",
                }))
                .reduce(concatNamesList(), "");
        },
    },
    methods: {
        openEditModal(id) {
            this.$router.push(`/meetings/details/${id}`);
        },
    },
};
</script>

<style scoped>
.meeting-item-left {
    flex: 1 1 40%;
    min-width: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.meeting-item-right {
    flex: 0 0 45%;
}
.meeting-item-picture {
    margin-left: -15px;
}
</style>
